module.exports = __webpack_public_path__ + "pc-download-logo-8cc58d0b.png";